import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/constants";

const WhatsAppButton = () => {
    return (
        <a
            data-testid="floating-whatsapp"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer"
            aria-label="Falar no WhatsApp"
            className="fixed bottom-6 left-6 md:bottom-8 md:left-8 z-40 group"
        >
            <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-30 animate-ping" />
            <span className="relative flex items-center gap-3 bg-[#25D366] hover:bg-[#1FB755] text-white font-bold text-sm uppercase tracking-wider px-5 py-4 shadow-2xl shadow-[#25D366]/40 transition-colors rounded-full">
                <MessageCircle className="w-5 h-5" />
                <span className="hidden sm:inline">WhatsApp</span>
            </span>
        </a>
    );
};

export default WhatsAppButton;
